import React from 'react';

const Insights = () => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="insights">
      <path
        d="M28.1667 29.3333V10.6667M20 29.3333V17.6667V29.3333ZM11.8333 29.3333V13V29.3333Z"
        stroke="#787F88"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Insights;
